import i18n from '@/plugins/vuei18n'

export default {
  props : ['context'],
  data () {
    return {
      nameRules: [
        v => !!v || i18n.t('schema.builder.inputs.name-required'),
        v => (v && v.length <= 1024) || i18n.t('schema.builder.inputs.too-long-name')
      ]
    }
  }
}
